import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-7xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-xl" }, "Confirmá tu asistencia completando el formulario", -1)
const _hoisted_4 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_5 = { class: "w-full px-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_9 = { class: "w-full px-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_13 = { class: "w-full px-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Mail", -1)
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_17 = { class: "w-full px-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_21 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "País", -1)
const _hoisted_23 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_25 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)
const _hoisted_27 = { class: "text-sm text-red-500 p-error" }
const _hoisted_28 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Número de teléfono", -1)
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_32 = { class: "w-full px-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Asiste", -1)
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_38 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700"
    }, {
      default: _withCtx(({ errors }) => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["w-full p-inputtext-sm", { 'p-invalid': errors.nombre }],
                    placeholder: "Nombre"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["w-full p-inputtext-sm", { 'p-invalid': errors.apellido }],
                    placeholder: "Apellido"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    class: ["w-full p-inputtext-sm", { 'p-invalid': errors.mail }],
                    placeholder: "Mail"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Field, {
                name: "empresa",
                modelValue: _ctx.formData.empresa,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    class: ["w-full p-inputtext-sm", { 'p-invalid': errors.empresa }],
                    placeholder: "Empresa"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_ErrorMessage, { name: "empresa" })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedCountry,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                filter: "",
                options: _ctx.paises,
                optionLabel: "value",
                placeholder: "Select a Country",
                class: "w-full md:w-14rem p-inputtext-sm"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              (_ctx.selectedCountry !== null)
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 0,
                    type: "text",
                    modelValue: _ctx.selectedCountry.code,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                    class: "w-full p-inputtext-sm",
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                name: "codigoArea",
                modelValue: _ctx.formData.codigoArea,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Field, {
                name: "numeroTelefono",
                modelValue: _ctx.formData.numeroTelefono,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.numeroTelefono) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "numeroTelefono" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_Field, {
                name: "asiste",
                modelValue: _ctx.formData.asiste,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.asiste) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    class: _normalizeClass([{ 'p-invalid': errors.asiste }, "w-full p-inputtext-sm"]),
                    placeholder: "Seleccione si va asistir",
                    options: _ctx.asistenciaSiNo,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_ErrorMessage, { name: "asiste" })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ])
          ], 512), [
            [_vShow, _ctx.withHash]
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              type: "submit",
              label: "REGISTRARME",
              class: "mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_37, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_38, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _createTextVNode(_toDisplayString(_ctx.textoBoton), 1)
            ], 8, _hoisted_36)
          ])
        ]),
        _createVNode(_component_BlockUI, {
          blocked: _ctx.isSubmitting,
          fullScreen: ""
        }, null, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}